import { Component, OnInit } from '@angular/core';
import {CardInfo} from "../models/cardmaster";
import {CardService} from "../services/card.service";
import {ActivatedRoute} from "@angular/router";

@Component({
  selector: 'app-cardview',
  templateUrl: './cardview.component.html',
})
export class CardviewComponent implements OnInit {

    cardinfo:CardInfo;
    constructor(
        private cardService:CardService,
        private activatedRoute: ActivatedRoute
    ) { }

    ngOnInit() {
        this.getCardInfo()
    }
    getCardInfo=function () {
        this.activatedRoute.params.subscribe(params => {
            let card_id = params['id'];
            console.log("CardId======>",card_id); // Print the parameter to the console.
            this.cardService.getCardInfo(card_id).then(data => {
                console.log("CardInfo=======>",data['data']);
                this.cardinfo = data['data'];
            });
        });

    }
}



// WEBPACK FOOTER //
// /home/sotsys211/work/src/ecard_new/backend/src/app/cardsmaster/cardview/cardview.component.ts